import { Alert, Autocomplete, Box, Card, CardContent, CardHeader, Divider, Paper, Stack, TextField, Typography } from "@mui/material";
import { Endereco, Movimentacao } from "../../../../data.types";
import { LocationOn } from "@mui/icons-material";

export function AutoCompletarEndereco(props: { enderecos: Endereco[], handleSelect: (endereco: Endereco) => any }) {
    const { enderecos, handleSelect } = props
    return (
        <Autocomplete
            fullWidth
            autoComplete={false}
            options={enderecos}
            autoHighlight
            getOptionLabel={(end) => end.rua}
            title="Informar Endereço"
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            disableClearable
            //popupIcon={<Search fontSize="small"  titleAccess="Selecionar Cliente"/>}
            //clearIcon={<ClearIcon fontSize="small" titleAccess="Remover"/>}
            renderOption={((props, end) => {
                const { key, ...optionProps } = props
                return (
                    <Box
                        key={key}
                        component={"li"}
                        {...optionProps}
                    >
                        <Stack flexDirection={"column"}>
                            <Typography variant="body1">{end.rua} {end.numero}</Typography>
                            <Typography variant="caption">{end.bairro}</Typography>
                        </Stack>
                    </Box>
                )
            })}
            renderInput={(params) =>
                <TextField
                    {...params}
                    autoComplete="new-password"
                    label="Informar Endereço"
                    slotProps={{
                        htmlInput: {
                            ...params.inputProps,
                        },
                    }}
                />
            }
            onChange={(ev, end) => {
                console.log("endereco selecionado",end);
                ev.preventDefault();
                if (end)
                    handleSelect(end);
            }}
        />
    )
}

interface CardEnderecoProps {
    mov: Movimentacao;
    mutatorLocal: (value: any, field: string) => any;
}
export const CardEndereco = (props:CardEnderecoProps) => {
    const { mov, mutatorLocal } = props
    return (
        <Card sx={{ flex: 1 }}>
            {mov.pessoa.enderecos.length > 1 && (
                <AutoCompletarEndereco enderecos={mov.pessoa.enderecos} handleSelect={end => mutatorLocal(end, "entrega")} />
            )}
            {mov.entrega && (
                <CardHeader
                    avatar={
                        <LocationOn fontSize="medium" />
                    }
                    title={mov.entrega.rua + " N°" + mov.entrega.numero}
                    subheader={mov.entrega.bairro}
                />
            )}

            {mov.pessoa._id && mov.pessoa.enderecos.length === 0 && (
                <Alert severity="error">Endereço não cadastrado!</Alert>
            )}
            <CardContent>
                {mov.entrega && (
                    <Stack spacing={1} flexDirection={"column"}>
                        <Typography variant="caption">{mov.entrega.cidade} {mov.entrega.uf}</Typography>
                        <Typography variant="caption">{mov.entrega.complemento}</Typography>
                    </Stack>
                )}
                {mov.entrega?.contato && (
                    <Paper elevation={3} sx={{flexDirection:"column",p:1}}>
                        <Typography variant="body1">Falar com:</Typography>
                        <Divider/>
                        <Box sx={{display:"flex", flexDirection:"row",justifyContent:"space-between",pt:1}}>
                            <Typography variant="caption">{mov.entrega.contato.nome}</Typography>
                            <Typography variant="caption">{mov.entrega.contato.whatsapp}</Typography>
                        </Box>
                    </Paper>
                )}
            </CardContent>

        </Card>
    )
}